import { useState, useRef } from "react";
import ArrowRight from "../../../assets/icons/arrow_right.png";
import { useFetch } from "../../../utils/hooks/useFetch";
import "./_videosection.scss";

const VideoSection = () => {
    const [videos] = useFetch("JSON/musicMedias.json");
    const videosToDisplay = videos.slice(0, 3);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const dialogRef = useRef();

    const openDialog = (video) => {
        setSelectedVideo(video);
        dialogRef.current?.showModal();
    }

    const closeDialog = () => {
        setSelectedVideo(null);
        dialogRef.current?.close();
    }

    return (
        <section>
            <a href="/videos" className="section-title-link">
                <h2>Vidéos</h2>
                <img src={ArrowRight} alt="arrow right" />
            </a>
            <h3>À la une</h3>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }} className="video-section-container">
                {videosToDisplay.map((obj, index) => (
                    <button
                        className="video-container"
                        key={index}
                        style={{ aspectRatio: "1.95" }}
                        onClick={() => openDialog(obj)}
                    >
                        <img src={obj.thumbnail} alt={obj.title} className="video-thumbnail" />
                    </button>
                ))}
            </div>

            <dialog ref={dialogRef} className="video-dialog" onClick={closeDialog}>
                {selectedVideo && (
                    <iframe
                        width="100%"
                        height="100%"
                        src={selectedVideo.iframe}
                        title={selectedVideo.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    />
                )}
            </dialog>
        </section>
    );
}

export default VideoSection;